export const holidays = [
    "2025-06-04",
    "2025-06-05",
    "2025-06-14",
    "2025-07-05",
    "2025-07-06",
    "2025-08-14",
    "2025-08-24",
    "2025-09-01",
    "2025-09-10",
    "2025-11-24",
    "2026-01-03",
    "2026-01-17",
    "2026-02-04",
    "2026-02-11",
    "2026-03-11",
    "2026-03-21",
    "2026-03-22",
    "2026-03-23",
    "2026-03-24",
    "2026-04-01",
    "2026-04-02",
    "2026-04-13",
    "2026-05-26",
    "2026-06-03",
    "2026-06-04",
    "2026-06-23",
    "2026-06-24",
    "2026-08-03",
    "2026-08-11",
    "2026-08-12",
    "2026-08-20",
    "2026-08-30",
    "2026-11-13",
    "2026-12-23",
    "2027-01-06",
    "2027-01-24",
    "2027-02-11",
    "2027-02-28",
    "2027-03-10",
    "2027-03-11",
    "2027-03-20",
    "2027-03-21",
    "2027-03-22",
    "2027-03-23",
    "2027-03-24",
    "2027-04-01",
    "2027-04-03",
    "2027-05-17",
    "2027-05-25",
    "2027-06-05",
    "2027-06-15",
    "2027-06-16",
    "2027-07-25",
    "2027-08-02",
    "2027-08-03",
    "2027-08-11",
    "2027-08-20",
    "2027-11-03",
    "2027-12-12",
    "2027-12-26",
    "2028-01-13",
    "2028-02-27",
    "2028-02-28",
    "2028-03-19",
];
